export const baseUrl = "http://www.veloxglobal.com/"
